import { useCallback, useEffect, useState } from 'react';
import type { Campaign } from '@ddp/shared';

import { apiFetch } from '../../api/client.js';

/**
 * Charge et rafraîchit les campagnes de l'organisation active.
 *
 * `refresh` est exposé pour être rappelé après une création ou une modification : les compteurs
 * et la barre de campagnes doivent se mettre à jour sans rechargement de page.
 */
export function useCampaigns() {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const list = await apiFetch<Campaign[]>('/campaigns');
      setCampaigns(list);
    } catch {
      // Rôle sans accès ou aucune campagne : la barre reste vide, sans bloquer la page.
      setCampaigns([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { campaigns, loading, refresh };
}
